var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTabs',{attrs:{"breadcrumbs":_vm.breadcrumbs,"tab":_vm.tab,"tabs":_vm.tabs},on:{"updateTab":_vm.onUpdateTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }